import React from 'react';
import { Grid, Typography, Box } from '@material-ui/core';
import { Copyright, Favorite } from '@material-ui/icons';
import { IMG_LOGO_WHITE } from 'images';
import './footer.scss';
import { useHistory } from 'react-router-dom';

const Footer = () => {
  const history = useHistory();

  return (
    <div className="sr-footer">
      <Grid container>
        <Grid item xs={12}>
          <Box className="sr-footer-bottom-bar">
            <img
              src={IMG_LOGO_WHITE}
              alt="Senseloaf"
              className="sr-footer-bottom-bar-logo"
            />
            <Copyright className="sr-footer-bottom-bar-copyright" />
            <Typography
              variant="body2"
              display="inline"
              className="sr-footer-bottom-bar-copyright-text"
            >
              {new Date().getFullYear()} Senseloaf Pvt LTD
            </Typography>
            <Box className="sr-footer-bottom-bar-links">
              <Typography variant="body2" display="inline">
                About
              </Typography>
              <Typography
                variant="body2"
                display="inline"
                className="sr-footer-link"
                onClick={() => history.push('/terms-of-service')}
              >
                Terms
              </Typography>
              <Typography
                variant="body2"
                display="inline"
                className="sr-footer-link"
                onClick={() => history.push('/privacy-policy')}
              >
                Privacy
              </Typography>
              <Typography variant="body2" display="inline">
                Made with{' '}
              </Typography>
              <Favorite className="sr-footer-bottom-bar-links-heart" />
              <Typography variant="body2" display="inline">
                {' '}
                BLR
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Footer;
